var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2501 13.6001V12.8501H8.7501V13.6001H10.2501ZM8.7501 13.6121V14.3621H10.2501V13.6121H8.7501ZM8.7501 5.8001V10.6001H10.2501V5.8001H8.7501ZM8.7501 13.6001V13.6121H10.2501V13.6001H8.7501ZM9.5001 17.6501C5.27512 17.6501 1.8501 14.2251 1.8501 10.0001H0.350098C0.350098 15.0535 4.44669 19.1501 9.5001 19.1501V17.6501ZM17.1501 10.0001C17.1501 14.2251 13.7251 17.6501 9.5001 17.6501V19.1501C14.5535 19.1501 18.6501 15.0535 18.6501 10.0001H17.1501ZM9.5001 2.3501C13.7251 2.3501 17.1501 5.77512 17.1501 10.0001H18.6501C18.6501 4.94669 14.5535 0.850098 9.5001 0.850098V2.3501ZM9.5001 0.850098C4.44669 0.850098 0.350098 4.94669 0.350098 10.0001H1.8501C1.8501 5.77512 5.27512 2.3501 9.5001 2.3501V0.850098Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.4cd76682d74f653890b117cd52f61110.svg";
export { ForwardRef as ReactComponent };